<template>
  <div class="mypage-favorite-player-select-pane">
    <player-select-list-section
      :listData="players"
      :selectedID="selectedID"
      @selectChange="changeSelected"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ComputedRef } from '@vue/composition-api'
import PlayerSelectListSection from '@/components/MypageFavoritePlayerSelectPage/MypageFavoritePlayerSelectPane/PlayerSelectListSection.vue'
import MessageDialogStore from '@/store/stores/pageStore/common/MessageDialogStore'
import StoreUtil from '@/store/StoreUtil'
import PlayerDocument from '@/store/stores/collectionModule/documents/player/PlayerDocument'
import LoginStore from '@/store/stores/loginStore/LoginStore'
import UserStore from '@/store/stores/pageStore/common/UserStore'

export type DataType = {
  selectedID: string
}

/**
 * マイページ: お気に入り選手変更 コンテンツペイン
 */
export default defineComponent({
  name: 'MypageFavoritePlayerSelectPane',
  components: {
    PlayerSelectListSection,
  },
  data(): DataType {
    return {
      /**
       * セレクトID
       */
      selectedID: '',
    }
  },
  setup() {
    const mypagePageStore = StoreUtil.useStore('MypagePageStore')

    return {
      fetchPlayers: mypagePageStore.fetchPlayers,
      players: mypagePageStore.availablePlayers as ComputedRef<Array<PlayerDocument>>,
      favoritePlayer: mypagePageStore.favoritePlayer,
      saveFavoritePlayer: mypagePageStore.saveFavoritePlayer,
    }
  },
  mounted() {
    this.selectedID = this.favoritePlayer ? this.favoritePlayer.sid : ''
  },
  methods: {
    async changeFavoritePlayer() {
      /**
       * お気に入り選手保存
       */
      const loader = this.$loading.show()
      const apiResult = await this.saveFavoritePlayer(this.selectedID)
      loader.hide()
      if (apiResult.isSuccess) {
        // グローバルストアに保持するユーザー情報を更新
        UserStore.value.fetchUserData(LoginStore.value.loginId)

        this.$emit('success-regist')
      } else {
        // API通信不具合
        await MessageDialogStore.value.open({
          title: this.$t('MypagePage.MypageFavoritePlayerSelectPage.errors.title') as string,
          message: this.$t('MypagePage.MypageFavoritePlayerSelectPage.errors.message') as string,
          errorApiResponse: apiResult.response,
        })
      }
    },
    changeSelected(selectedItemID: string): void {
      /**
       * 選択変更
       * @param selectedItemID : string
       */
      this.selectedID = this.selectedID === selectedItemID ? '' : selectedItemID
    },
  },
})
</script>

<style lang="scss" scoped>
.mypage-favorite-player-select-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{env(safe-area-inset-bottom)});
  padding: 24px 0 104px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
